import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "feedbacks" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "feedbackscard" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks_all_list, (ele) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(ele.name), 1),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: 'mailto:' + ele.email
          }, _toDisplayString(ele.email), 9, _hoisted_4)
        ]),
        _createElementVNode("p", null, _toDisplayString(ele.feedback), 1)
      ]))
    }), 256))
  ]))
}